import Vue from 'vue';


//============================================================


// Denna modul är "reusable" och används av apparna för Kundreskontra och Leverantörsreskontra:
const modul = {
	namespaced: true,

	// Denna är en function för att denna modul ska kunna vara "reusable" och används av flera appar/sidor::
	state () {
		return {

			// Indexerad 0–n enligt respektive grupps gruppIndex-värde:
			gruppExpanderad: [false, false, false, false, false, false],		// = initialt defaultvärde

	
			rullningsbaraElement: [ 	// = initiala defaultvärden
				{ id:'re0', scrollTop: 0 },	// Containern runt alla grupperna
				{ id:'re1', scrollTop: 0 },	// Grupp 1
				{ id:'re2', scrollTop: 0 },	// Grupp...
				{ id:'re3', scrollTop: 0 },
				{ id:'re4', scrollTop: 0 },
				{ id:'re5', scrollTop: 0 },
				{ id:'re6', scrollTop: 0 }
			]
		};
	},

	getters: {

		//// Method-Style Access:
		//// Note that getters accessed via methods will run each time you call them, and the result is not cached:
		////getGruppExpanderad: (state) => (gruppIndex) => {
		////	return state.gruppExpanderad[gruppIndex];
		////},
		//getGruppExpanderad: function(state, getters, rootState, rootGetters) {
		//	return (gruppIndex) => state.gruppExpanderad[gruppIndex];
		//},

	},

	mutations: {

		setGruppExpanderad(state, payload)
		{
			// https://vuejs.org/v2/guide/list.html#Caveats: Due to limitations in JavaScript, Vue cannot detect (is NOT reactive) when you directly set an array-item with the index, e.g. vm.items[indexOfItem] = newValue.
			//state.gruppExpanderad[gruppIndex] = nyttVarde;
			Vue.set(state.gruppExpanderad, payload.gruppIndex, payload.nyttVarde);
		}

	}

	//actions: { ... },
};

export { modul as ssoStatestoreReskontra };
